import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NavigationStart, Router } from '@angular/router';
import { ofType } from '@ngrx/effects';
import { ActionsSubject, Store, select } from '@ngrx/store';
import { ActiveCartService, CartActions, MULTI_CART_FEATURE, StateWithMultiCart } from '@spartacus/cart/base/core';
import { OrderEntry } from '@spartacus/cart/base/root';
import { GlobalMessageService, GlobalMessageType, Product, ProductScope, ProductService } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CurrentProductService } from '@spartacus/storefront';
import { uniqBy } from 'lodash';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import {
  concatMap,
  distinctUntilChanged,
  filter,
  map,
  pairwise,
  startWith,
  switchMap,
  take,
  tap,
} from 'rxjs/operators';
import { ShimanoProduct, VariantType } from 'src/app/model/product.model';
import { BaseSiteConfigService } from 'src/app/service/base-site/base-site-config.service';
import { BaseStoreService } from 'src/app/service/base-store/base-store.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import {
  GoogleTagManagerEvent,
  GoogleTagManagerService,
} from 'src/app/service/googletagmanager/google-tag-manager.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { OrderHistoryService } from 'src/app/service/orders/order-history.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { ShimanoUtilMethod } from 'src/app/utility/methods.util';

@Component({
  selector: 'app-product-list-grid-modal',
  templateUrl: './product-list-grid-modal.component.html',
  styleUrl: './product-list-grid-modal.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AsyncPipe],
  standalone: false,
})
export class ProductListGridModalComponent implements OnInit, OnDestroy {
  @ViewChild('skuVariantsSelector', { static: false }) private skuVariantsSelector: ElementRef<HTMLInputElement>;
  defaultVariantCategory = 'cgvvc_SHIC_default_default';
  defaultSuperCategory: 'cgvc_SHIC_default';
  product: any;
  selected: string;
  dealerPrice: string;

  product$: Observable<ShimanoProduct> = this.currentProductService.getProduct() as Observable<ShimanoProduct>;
  isLanguageChanged = false;
  productsFromGrid$: Observable<Product>;

  variants: any = [];
  variantsKeys: any = [];
  selectedCategoryGroup: any = [];
  variantType = VariantType;
  selectedVariantIndex: number;
  selectedVariant: string;
  singleOption = false;
  prodCode: any;
  default = 'default';
  loading = false;
  productSubscription$: Subscription;
  productCode: string;
  cartEntry$: Observable<OrderEntry>;

  quantity = 1;
  hasStock = false;
  maxQuantity: number;
  subscription: Subscription;
  baseProduct$: Observable<Product>;
  @Input() showOrderFormLink = true;
  minOrderQuantity = 1;
  addToCartForm = new FormGroup({
    quantity: new FormControl(1),
  });

  addToCartInprogress = false;
  isBackOrderPopupEnabled: boolean = false;
  showBackorderCartModal = false;
  pageType: string = 'PDP';
  increment = false;
  updatedQuantityAdded: number;
  cart: any;
  backOrderModalSubscription: Subscription;
  dealerPriceCheckerSubscription$: Subscription;
  breakpointSubscription$: Subscription;
  isMobileSize: boolean;
  srpSubscription$: Subscription;
  showSrp = false;
  erpPromotions$: Observable<any>;
  hasDealerPrice = true;
  additionalHeight = '';

  cartAddEntrySuccessSubscription$: Subscription;
  quantityAdded: number;
  hasCartAddEntrySuccess = false;
  cartAddEntryFail = false;
  orderFormGtmDataLayer: any;

  orderFormItems: any = [];
  categories: any = {};
  activeCountry$: Observable<string> = this.countryService.getActive();
  activeLanguage$: Observable<string> = this.languageService.getActive();
  businessType: string = this.currentBusinesstype.getBusinessType();
  currentCountry = this.pipeAsync.transform(this.activeCountry$);
  activeLanguage = this.pipeAsync.transform(this.activeLanguage$);
  pdpDealerPrice: number;
  orderFormTotalPrice = 0;
  orderFormTotalPriceSubscription$: Subscription;

  affiliation = `/${this.businessType}/${this.currentCountry}/${this.activeLanguage}`;

  addToCartInprogressModal = false;
  backorderEntries: any;
  formEntries: any;
  private dateFormatted: any;
  public filteredEntries: any;
  private findQty: any;
  cartId: string;
  nonBackorder: any;
  saveCartDetailsFormModelSubscription$: Subscription;
  saveCartDetailsFormGroupSubscription$: Subscription;

  notAavailableVvc: any;
  availableVvc: any;
  availableVvcUnique: any;
  notAavailableVvcUnique: any;
  finalVariants: any;
  filteredVariantsMap: any = [];

  constructor(
    protected productService: ProductService,
    protected modalService: StandardModalService,
    protected el: ElementRef,
    protected vcr: ViewContainerRef,
    protected cartService: ActiveCartService,
    private currentProductService: CurrentProductService,
    private languageService: ShimanoLanguageService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    private dealerPriceService: DealerPriceService,
    private orderHistoryService: OrderHistoryService,
    private messageService: GlobalMessageService,
    private store: Store<StateWithMultiCart>,
    private baseSiteConfigService: BaseSiteConfigService,
    private actionsSubject: ActionsSubject,
    private currentBusinesstype: CurrentBusinessType,
    private countryService: ShimanoCountryService,
    private pipeAsync: AsyncPipe,
    private gtmService: GoogleTagManagerService,
    private storageService: StorageService,
    private baseStoreService: BaseStoreService,
    private breakpointService: BreakpointService,
    private router: Router
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => {
        this.variantFunction(res.product.code);
        this.showSrp = res.hasShowSrp;
      });

    // Close modal when route changes
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.closeModal('Cross click');
      }
    });
  }

  ngOnInit(): void {
    this.adjustVariantHeight();
    this.breakpointSubscription$ = this.breakpointService.breakpoint$.subscribe((breakpoint) => {
      this.isMobileSize = breakpoint !== BREAKPOINT.lg && breakpoint !== BREAKPOINT.xl;
      this.adjustVariantHeight();
      this.cdr.detectChanges();
    });
    this.isBackOrderModalEnabled();
    this.dealerPriceCheckerSubscription$ = this.componentService.hasDealerPrice$.subscribe((hasDealerPrice) => {
      this.hasDealerPrice = hasDealerPrice;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });

    this.cartAddEntrySuccessSubscription$ = this.actionsSubject
      .pipe(ofType(CartActions.CART_ADD_ENTRY_SUCCESS, CartActions.CART_ADD_ENTRY_FAIL))
      .pipe(
        map((cartAddEntryStatus: any) => {
          if (cartAddEntryStatus.type === CartActions.CART_ADD_ENTRY_SUCCESS) {
            this.quantityAdded = cartAddEntryStatus.payload.quantityAdded;
            this.hasCartAddEntrySuccess = true;
          } else {
            this.quantityAdded = 0;
            this.cartAddEntryFail = true;
          }
          return cartAddEntryStatus;
        }),
        concatMap(() => this.cartService.isStable().pipe(distinctUntilChanged()))
      )
      .subscribe((isCartLoaded) => {
        if (isCartLoaded) {
          this.addToCartInprogress = false;
          this.componentService.setMiniCartLoading(false);
          this.cdr.detectChanges();
          if (this.hasCartAddEntrySuccess) {
            this.updateLoaderCTA(this.cart);
            this.hasCartAddEntrySuccess = false;
          }

          if (this.quantityAdded) {
            this.gtmAddToCart(this.product, this.quantityAdded);
          } else if (this.updatedQuantityAdded > 0) {
            this.gtmAddToCart(this.product, this.updatedQuantityAdded);
          }
        } else {
          if (!this.showBackorderCartModal) {
            this.addToCartInprogress = true;
            this.componentService.setMiniCartLoading(true);
          }
        }
        this.cdr.detectChanges();
      });
    this.orderFormTotalPriceSubscription$ = this.componentService.orderFormTotalPrice$.subscribe(
      (orderFormTotalPrice) => {
        this.orderFormTotalPrice = orderFormTotalPrice;
        this.cdr.detectChanges();
      }
    );
    this.baseStoreService
      .getBasestoreData()
      .pipe(take(1))
      .subscribe((baseStoreData) => {
        this.dateFormatted = baseStoreData.dateFormat.replace(/\//g, '-');
      });
  }

  adjustVariantHeight() {
    const promotionStockstatus = document.getElementById('promotionStockstatus');
    const addToCartHeight = document.getElementById('addToCartHeight');
    const variantContainer = document.getElementById('variantContainer');
    if (addToCartHeight && variantContainer) {
      const addToCartRects = addToCartHeight?.getBoundingClientRect();
      const variantContainerRects = variantContainer?.getBoundingClientRect();
      const distance = addToCartRects.top - variantContainerRects.top;
      const totalDistance = distance - promotionStockstatus.offsetHeight;
      this.additionalHeight = totalDistance.toString() + 'px';
    }
  }

  // S T A R T  O F   B A C K O R D E R   M O D A L

  checkboxUpdate() {
    this.filteredEntries = this.backorderEntries?.inventoryBackorderList?.filter(
      (entry: { checkBox: any }) => entry.checkBox === true
    );
    if (this.backorderEntries?.inventoryBackorderList?.length > 0) {
      if (typeof this.formEntries !== 'undefined') {
        // Check the entries for property productCode which comes from order form
        if (this.formEntries[0]?.hasOwnProperty('productCode')) {
          // Order Form entry adding logic
          this.nonBackorder = this?.formEntries?.filter(
            (entry: any) =>
              !this.backorderEntries?.inventoryBackorderList?.find(
                (item: any) => entry?.productCode === item?.productId
              )
          );
        }
      }
    }
  }

  saveBackorder() {
    if (!this.addToCartInprogressModal) {
      this.addToCartInprogressModal = true;

      this.filteredEntries = this.backorderEntries?.inventoryBackorderList?.filter(
        (entry: { checkBox: any }) => entry?.checkBox === true
      );

      this.cartService
        .getActiveCartId()
        .pipe(map((data) => data))
        .subscribe((results) => {
          this.cartId = results;
        })
        .unsubscribe();

      this.componentService.setMiniCartLoading(true);
      this.cdr.detectChanges();

      // Filtering the selected entries depending on checkbox selection
      this.filteredEntries.forEach((item: { quantity: number; productId: any }) => {
        // non orderForm inputs
        if (this?.formEntries?.orderEntries) {
          this.findQty = this.formEntries.orderEntries.find((obj: any) => {
            return obj.product.code === item.productId;
          });
        } else {
          if (this.formEntries[0]?.hasOwnProperty('code')) {
            this.findQty = this?.formEntries.find((obj: any) => {
              return obj.code === item.productId;
            });
          } else {
            this.findQty = this?.formEntries.find((obj: any) => {
              return obj.productCode === item.productId;
            });
          }
        }
        if (this?.findQty?.quantity) {
          this.quantity = this?.findQty.quantity;
        } else {
          this.quantity = this?.findQty.qty;
        }
        if (!item.productId || this.quantity <= 0) {
          return;
        }
        this.addToCartBackorderModal(item.productId, this.quantity);
      });
    }
  }

  addToCartBackorderModal(productCode: any, quantity: number) {
    this.componentService.setMiniCartLoading(true);
    this.cdr.detectChanges();
    if (!productCode || quantity <= 0) {
      return;
    }
    this.cartService
      .getEntry(productCode)
      .subscribe(
        (entry) => {
          if (entry) {
            this.increment = true;
            if (entry.product.stock.stockLevel < entry.quantity + quantity) {
              this.updatedQuantityAdded = entry.product.stock.stockLevel - entry.quantity;
            }
          }
          this.cartService.addEntry(productCode, quantity);
          this.increment = false;
          this.cart = this.cartService.isStable();
          const cartStatus = this.cart.subscribe((cart: any) => {
            if (cart) {
              this.addToCartInprogressModal = false;
              this.cdr.detectChanges();
              setTimeout(() => {
                const hasError = sessionStorage.getItem('InsufficientStockError');

                if (hasError === null) {
                  if (this.pageType === 'PDP' && this?.nonBackorder?.length === undefined) {
                    this.showGlobalMessage(
                      'cart.addToCartSuccess',
                      GlobalMessageType.MSG_TYPE_CONFIRMATION,
                      productCode
                    );
                    cartStatus.unsubscribe();
                  }

                  if (this.pageType === 'quickorder') {
                    this.showGlobalMessage(
                      'cart.quickOrder.submitModal.success',
                      GlobalMessageType.MSG_TYPE_CONFIRMATION
                    );
                    cartStatus.unsubscribe();
                  }
                  this.backToProductModal();
                } else {
                  this.closeModal('hasError');
                }

                sessionStorage.removeItem('InsufficientStockError');
                this.componentService.setMiniCartLoading(false);
                cartStatus.unsubscribe();
                this.cdr.detectChanges();
              }, 1000);
            }
          });
        },
        (err) => {
          this.componentService.setMiniCartLoading(false);
          this.cdr.detectChanges();
          this.messageService.add({ key: 'cart.quickOrder.submitModal.error' }, GlobalMessageType.MSG_TYPE_ERROR);
        }
      )
      .unsubscribe();
  }
  // E N D   O F   B A C K O R D E R   M O D A L

  gtmAddToCart(product: any, quantity: number, orderFormProductsDetails?: any[]) {
    this.orderFormItems = [];
    this.categories = {};
    product.categories.forEach((cat: any, i: any) => {
      const indexCount = i + 1;
      const label = `item_category${indexCount == 1 ? '' : indexCount}`;
      this.categories[label] = cat.name;
    });

    if (orderFormProductsDetails) {
      orderFormProductsDetails
        .filter((o) => o.quantity > 0)
        .forEach((item: any) => {
          const initialItem = {
            item_id: item.id,
            item_name: item.name,
            affiliation: this.affiliation,
            item_brand: product?.brand?.name,
            ...this.categories,
            price: item.price,
            quantity: item.quantity,
          };
          this.orderFormItems.push(initialItem);
        });
    }
    let totalValue = 0;
    let dealerPrice = this.pdpDealerPrice ? this.pdpDealerPrice : 0;
    totalValue = dealerPrice * quantity;
    const gtmTag = {
      event: GoogleTagManagerEvent.ADD_TO_CART,
      ecommerce: {
        currency: this.storageService.getSessionStorageItem('currency'),
        value: !orderFormProductsDetails ? totalValue.toFixed(2) : this.orderFormTotalPrice.toFixed(2),
        items: !orderFormProductsDetails
          ? [
              {
                item_id: product.code,
                item_name: product.name,
                affiliation: this.affiliation,
                item_brand: product?.brand?.name,
                ...this.categories,
                price: dealerPrice,
                quantity,
              },
            ]
          : this.orderFormItems,
      },
    };
    if (gtmTag.ecommerce.items.length > 0) {
      this.gtmService.pushTag({
        ecommerce: null,
        search_term: '',
        results_page: '',
        affiliation: '',
        content_type: '',
        content_id: '',
        content_name: '',
      });
      this.gtmService.pushTag(gtmTag);
    }
  }

  updateLoaderCTA(cart: any) {
    if (cart) {
      cart.pipe(take(1)).subscribe(
        (cart: any) => {
          if (
            !cart.carts?.entities[cart.index.Active]?.loading &&
            !cart.carts?.entities[cart.index.Active]?.error &&
            cart.carts?.entities[cart.index.Active]?.success
          ) {
            this.componentService.setMiniCartLoading(false);
            this.cdr.detectChanges();
            //both PDP and EV
            if (this.pageType === 'PDP') {
              this.showGlobalMessage('cart.addToCartSuccess', GlobalMessageType.MSG_TYPE_CONFIRMATION, this.prodCode);
            }
            this.addToCartInprogress = false;
            this.cdr.detectChanges();
          }
          if (
            !cart.carts?.entities[cart.index.Active]?.loading &&
            cart.carts?.entities[cart.index.Active]?.error &&
            !cart.carts?.entities[cart.index.Active]?.success
          ) {
            this.addToCartInprogress = false;
            this.componentService.setMiniCartLoading(false);
            this.cdr.detectChanges();
          }
        },
        (error: any) => {
          this.addToCartInprogress = false;
          this.componentService.setMiniCartLoading(false);
          this.cdr.detectChanges();
        }
      );
    }
  }

  backorderCartCheck() {
    if (!this.addToCartInprogress) {
      this.addToCartInprogress = true;
      if (this.isBackOrderPopupEnabled) {
        const body = {
          orderEntries: [
            {
              quantity: this.addToCartForm.get('quantity').value,
              product: {
                code: this.prodCode,
              },
            },
          ],
        };

        const entries = this.orderHistoryService.getInventory(body);
        entries.pipe(map((datas) => datas)).subscribe({
          next: (data) => {
            if (data.inventoryBackorderList?.length > 0) {
              this.backorderCartModal(data, body);
            } else {
              this.addToCart();
            }
          },
          error: (error) => {
            this.addToCartInprogress = false;
            this.showGlobalMessage('cart.genericError', GlobalMessageType.MSG_TYPE_ERROR);
          },
          complete: () => {},
        });
      } else {
        this.addToCart();
      }
    }
  }

  addToCart() {
    this.componentService.setMiniCartLoading(true);
    this.cdr.detectChanges();
    const quantity = this.addToCartForm.get('quantity').value;
    if (!this.prodCode || quantity <= 0) {
      return;
    }
    this.cartService
      .getEntry(this.prodCode)
      .pipe((map) => map)
      .subscribe({
        next: (entry) => {
          if (entry) {
            this.increment = true;
            if (entry.product.stock.stockLevel < entry.quantity + quantity) {
              this.updatedQuantityAdded = entry.product.stock.stockLevel - entry.quantity;
            }
          }
          this.cartService.addEntry(this.prodCode, quantity);
          this.increment = false;
          this.cart = this.store.pipe(select(MULTI_CART_FEATURE));
        },
        error: (err) => {
          this.addToCartInprogress = false;
          this.componentService.setMiniCartLoading(false);
          this.cdr.detectChanges();
        },
      })
      .unsubscribe();
  }

  private showGlobalMessage(text: string, messageType: GlobalMessageType, param?: string) {
    this.messageService.add({ key: text, params: { productName: param } }, messageType);
  }

  ngAfterViewChecked() {
    this.checkAndRemoveEmptyParents();
  }

  checkAndRemoveEmptyParents() {
    const parents = document.querySelectorAll('.sku-variants-selector');

    parents.forEach((parentDiv) => {
      const childElements = parentDiv.querySelectorAll('.variant-value-list');
      let hasContent = false;

      childElements.forEach((child) => {
        const hasTextContent = child.textContent?.trim().length > 0;
        const hasImageContent = child.querySelector('img, .cx-media');

        if (hasTextContent || hasImageContent) {
          hasContent = true;
        }
      });

      if (!hasContent) {
        parentDiv.remove();
      }
    });
  }

  backorderCartModal(cart: any = null, entries: any): void {
    this.addToCartInprogress = false;
    this.showBackorderCartModal = true;
    this.backorderEntries = cart;
    if (cart && cart.inventoryBackorderList) {
      this.backorderEntries.inventoryBackorderList = cart.inventoryBackorderList.map((item: any) => {
        return { ...item, checkBox: true };
      });
    }
    this.formEntries = entries;
    this.checkboxUpdate();
    this.cdr.detectChanges();
  }

  isBackOrderModalEnabled = () => {
    this.backOrderModalSubscription = this.getBackOrderModalConfig$().subscribe((backOrder) => {
      this.isBackOrderPopupEnabled = backOrder === 'true';
      this.cdr.detectChanges();
    });
  };

  getBackOrderModalConfig$(): Observable<string> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.backorder.popup.message'])
      .pipe(
        map(
          (configs) =>
            configs &&
            configs
              .filter((config: any) => config.key === 'shimano.backorder.popup.message')
              .map((res: any) => res.value)[0]
        )
      );
  }

  get hasInvalidQuantity(): boolean {
    return this.quantity <= 0 && this.addToCartForm.get('quantity').value <= 0;
  }

  initialAddToCartSetup() {
    if (this.product) {
      this.cartEntry$ = this.cartService.getEntry(this.prodCode);
      this.hasStock = true;
      this.setStockInfo(this.product);
      this.cdr.markForCheck();
      if (this.product?.minOrderQuantity) {
        this.minOrderQuantity = this.product.minOrderQuantity;
        this.addToCartForm.patchValue({ quantity: this.product.minOrderQuantity });
      } else {
        this.minOrderQuantity = 1;
        this.quantity = 1;
        this.addToCartForm.patchValue({ quantity: this.quantity });
      }
    }
  }

  updateCount(value: number): void {
    this.quantity = value;
  }
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  setStockInfo(product: Product): void {
    this.quantity = 1;
    this.hasStock = product.stock && product.stock.stockLevelStatus !== 'outOfStock';
    if (this.hasStock && product.stock.stockLevel) {
      this.maxQuantity = product.stock.stockLevel;
    }
  }
  checkSalesRepStockData(salesRepStockData: any) {
    let finalStocks = [];
    const stocks = salesRepStockData.slice(0, 2);
    if (stocks.length > 0) {
      if (stocks.every((item: any) => item.stockLevelStatus === 'outOfStock')) {
        finalStocks = stocks.slice(0, 1);
      } else {
        finalStocks = stocks.filter((item: any) => item.stockLevelStatus !== 'outOfStock');
      }
    }
    return finalStocks;
  }

  salesRepStockData(salesRepStockData: any): boolean {
    if (salesRepStockData) {
      if (salesRepStockData.length < 1) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  variantFunction(productCode: any) {
    this.getDealerPrice([productCode]);
    this.productSubscription$ = combineLatest([
      this.languageService.getActive().pipe(startWith(null), pairwise()),
      this.productService.get(productCode, ProductScope.DETAILS),
    ])
      .pipe(
        switchMap(([[prevLanguage, currentLanguage], product]) => {
          prevLanguage !== currentLanguage ? (this.isLanguageChanged = true) : (this.isLanguageChanged = false);
          return of(product);
        }),
        filter((product) => !!(product && product.baseOptions)),
        distinctUntilChanged(),
        tap((product) => {
          this.product = product;
          this.initialAddToCartSetup();

          this.productsFromGrid$ = of(product);
          if (this.prodCode !== product.code || this.isLanguageChanged) {
            this.update();
            this.variants = [];
            this.variantsKeys = [];
            const selectedVariant = (element: any) => element.variantOption.code === product.code;
            if (typeof product.variantMatrix !== 'undefined') {
              this.selectedVariantIndex = product.variantMatrix.findIndex(selectedVariant);
              this.selectedVariant = product.variantMatrix.find(selectedVariant).variantOption.code;
              this.flattenOptions(product.variantMatrix, product.baseOptions[0].options, null, []);
              this.filteredVariantsMap = this.variantsKeys.reduce((acc: any, key: any) => {
                acc[key] = this.combinedAllVVC(this.variants[key]);
                return acc;
              }, {});
            }
            if (this.variantsKeys.length === 1) {
              this.singleOption = this.variantsKeys.includes(this.defaultVariantCategory);
            } else {
              this.singleOption = false;
            }
            if (Object.keys(this.variants).length > 2) {
              sessionStorage.setItem('disableOrderFormsProductPage', 'false');
            } else {
              sessionStorage.setItem('disableOrderFormsProductPage', 'true');
            }
            this.prodCode = product.code;
            this.loading = false;
            this.componentService.setIsLoadAddToCartDisabled(false);
          }
        })
      )
      .subscribe();
  }

  flattenOptions(matrixElement: any, baseOptions: any, overrideIndex: any, parentCategory: any) {
    matrixElement.forEach((option: any, index: any) => {
      if (option && option.variantValueCategory) {
        const optionFromBase = {
          option: baseOptions.filter((opt: any) => {
            return opt.code === option.variantOption.code;
          })[0],
        };

        if (option.variantOption.code === this.selectedVariant) {
          this.selectedCategoryGroup.push(option.variantValueCategory.name);
        }

        const combine = {
          ...option.variantOption,
          ...option.variantValueCategory,
          ...{ hasImage: option.parentVariantCategory.hasImage },
          ...optionFromBase,
          ...{ indexSelected: overrideIndex !== null ? overrideIndex : index },
          ...{ variantSelected: option.variantOption.code === this.selectedVariant ? true : false },
          ...{ categorySelected: this.selectedCategoryGroup },
          ...{ prevCategory: parentCategory.length > 0 ? parentCategory : [] },
        };

        const tempArray = this.variants[option.parentVariantCategory.name] || [];

        this.variants[option.parentVariantCategory.name] = [...tempArray, combine];

        if (!this.variantsKeys.includes(option.parentVariantCategory.name)) {
          if (option.parentVariantCategory.name !== 'N/A') {
            this.variantsKeys.push(option.parentVariantCategory.name);
          }
        }

        this.variants[option.parentVariantCategory.name].sort((a: any, b: any) => (a.sequence > b.sequence ? 1 : -1));
        if (option.elements.length > 0) {
          let parentName = [];
          if (parentCategory.length > 0) {
            parentName = parentCategory.concat([option.variantValueCategory.name]);
          } else {
            parentName = [option.variantValueCategory.name];
          }
          this.flattenOptions(option.elements, baseOptions, index, parentName);
        }
      }
    });
  }

  combinedAllVVC(variantsKeys: any) {
    this.notAavailableVvc = [];
    this.notAavailableVvcUnique = [];
    this.availableVvc = [];
    variantsKeys.forEach((vvc: any) => {
      const vvcObj = vvc;
      if (vvc.prevCategory.length > 0) {
        const category = vvc.categorySelected;
        let notavailable = false;
        vvc.prevCategory.forEach((cat: any, index: any) => {
          if (category[index] !== cat) {
            notavailable = true;
          }
        });
        if (notavailable) {
          this.notAavailableVvc.push({ ...vvcObj, available: false });
        } else {
          this.availableVvc.push({ ...vvcObj, available: true });
        }
      } else {
        this.availableVvc.push({ ...vvcObj, available: true });
      }
    });
    this.availableVvcUnique = uniqBy(this.availableVvc, 'name');
    this.notAavailableVvcUnique = uniqBy(this.notAavailableVvc, 'name');
    let finalNotAvailable = this.notAavailableVvcUnique.filter(
      (notavail: any) => !this.availableVvcUnique.some((avail: any) => avail.name === notavail.name)
    );
    if (finalNotAvailable.length) {
      this.finalVariants = [...this.availableVvcUnique, ...finalNotAvailable];
    } else {
      this.finalVariants = this.availableVvcUnique;
    }
    this.finalVariants.sort((firstItem: any, secondItem: any) => firstItem.sequence - secondItem.sequence); //sort by sequence property
    return this.finalVariants;
  }

  showProductSelectedVariant(category: any, prevSelected: any) {
    let showVariantCategory = true;
    prevSelected.forEach((cat: any, index: any) => {
      if (category[index] !== cat) {
        showVariantCategory = false;
      }
    });
    return showVariantCategory;
  }

  changeVariant(productCode: string, selectedVariant: any) {
    if (productCode && !selectedVariant) {
      this.loading = true;
      setTimeout(() => {
        this.update();
        this.variantFunction(productCode);
      }, 500);
    }
  }

  update() {
    this.selectedCategoryGroup = [];
    this.variantsKeys = [];
    this.variants = [];
  }

  getDealerPrice(productCodes: string[]) {
    this.dealerPriceService
      .getDealerPricesByProductCodes(productCodes)
      .pipe(take(1))
      .subscribe((data) => {
        this.erpPromotions$ = of(data);
        const dPrice = data?.dealerPrices[0]?.price;
        if (dPrice === undefined) {
          this.dealerPrice = '';
        } else {
          this.dealerPrice = dPrice.formattedValue;
        }
      });
  }

  getFirstVariantProductImageAltText(code: string): string {
    if (this.product && this.product.code === code) {
      if (this.product.images) {
        return this.product?.images?.PRIMARY?.product.url;
      } else {
        return '';
      }
    }
    return '';
  }

  getImageRendition(image: any) {
    let size: string;
    size = ShimanoUtilMethod.imageRendition(240);
    return ShimanoUtilMethod.newImageFormat(image, size);
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }

  backToProductModal() {
    this.showBackorderCartModal = false;
  }

  @HostListener('click', ['$event'])
  handleClick(event: UIEvent): void {
    if ((event.target as any).tagName === this.el.nativeElement.tagName) {
      this.closeModal('Cross click');
    }
  }

  isColors(variants: any) {
    if (variants.length > 0) {
      if (variants[0].hasImage) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  getDealerPrices(productCodes: string[]): Observable<any> {
    return this.dealerPriceService.getDealerPricesByProductCodes(productCodes);
  }

  ngOnDestroy(): void {
    if (this.productSubscription$) {
      this.productSubscription$.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.backOrderModalSubscription) {
      this.backOrderModalSubscription.unsubscribe();
    }
    if (this.orderFormTotalPriceSubscription$) {
      this.orderFormTotalPriceSubscription$.unsubscribe();
    }
    if (this.saveCartDetailsFormModelSubscription$) {
      this.saveCartDetailsFormModelSubscription$.unsubscribe();
    }
    if (this.saveCartDetailsFormGroupSubscription$) {
      this.saveCartDetailsFormGroupSubscription$.unsubscribe();
    }
    if (this.cartAddEntrySuccessSubscription$) {
      this.cartAddEntrySuccessSubscription$.unsubscribe();
    }
  }
}
